import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useContent } from '../../content';

const Intro = () => {
    const navigate = useNavigate();
    const { getC, loaded } = useContent(['beyond']);

    if (!loaded) return <div />;

    return (
        <div className="beyond-test-container">
            <div className="intro-card">
                <h1>{getC('beyond.beyond_test.title')}</h1>
                <p className="subtitle">Ideal Self & Future Relations</p>

                <div className="intro-content">
                    <p>
                        {getC('beyond.beyond_test.description')}
                    </p>
                </div>

                <button className="start-btn" onClick={() => navigate('/beyond-test/q/1')}>
                    Start Test
                </button>
            </div>

            <style jsx>{`
        .beyond-test-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: linear-gradient(135deg, #0f172a 0%, #312e81 100%);
          color: white;
        }

        .intro-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 24px;
          padding: 3rem 2rem;
          text-align: center;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
          animation: fadeIn 0.8s ease-out;
        }

        h1 {
          font-size: 2.2rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          background: linear-gradient(to right, #a78bfa, #f472b6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .subtitle {
          color: #94a3b8;
          font-size: 0.9rem;
          margin-bottom: 2rem;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .intro-content {
          margin-bottom: 3rem;
          line-height: 1.8;
          font-size: 1.1rem;
          color: #e2e8f0;
        }

        .start-btn {
          width: 100%;
          padding: 1.2rem;
          font-size: 1.1rem;
          font-weight: 600;
          color: white;
          background: linear-gradient(to right, #8b5cf6, #ec4899);
          border: none;
          border-radius: 16px;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .start-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(139, 92, 246, 0.3);
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
        </div>
    );
};

export default Intro;
